import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import MailIcon from "@mui/icons-material/Mail";
import AgentJwtService from 'app/services/agent/AgentJwtService';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from 'app/agent/store/agentUserSlice';
import { Button, Hidden, Icon, InputAdornment, TextField, Popover, useMediaQuery, Stack, ListSubheader } from "@mui/material";
import { FiSearch, FiBell } from "react-icons/fi";
import { MdPowerSettingsNew } from "react-icons/md";
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Add } from "@mui/icons-material";
import PublicSidebarLeft from "../public-sidebar-left/PublicSidebarLeft";
import SearchBar from "../search/SearchBar";


const BadgeStyled = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-anchorOriginTopRightRectangular': {
        right: '6px', "&::after": {
            color: "#FF4848",
            backgroundColor: "#FF4848",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            animation: "ripple 1.2s infinite ease-in-out",
            border: "1px solid currentColor",
            content: '""',
        },
        "@keyframes ripple": {
            "0%": {
                transform: "scale(.8)",
                opacity: 1,
            },
            "100%": {
                transform: "scale(2.4)",
                opacity: 0,
            },
        },
    }
}));
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

class PiLogo extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className=" max-w-288" viewBox="0 0 280.511 50.116"><g transform="translate(0)"><g transform="translate(0 0)"><path d="M601.338,0h0A25.061,25.061,0,0,1,626.4,25.058h0a25.061,25.061,0,0,1-25.058,25.058h0A25.061,25.061,0,0,1,576.28,25.058h0A25.061,25.061,0,0,1,601.338,0Z" transform="translate(-576.28)" fill="#fc0" /><path d="M623.448,27.365a19.81,19.81,0,0,1-30,16.988,1.215,1.215,0,0,1-.125-.077,19.714,19.714,0,0,1-5.106-4.466,1,1,0,0,1-.125-.174,19.805,19.805,0,0,1,25.726-29.26h.028a19.7,19.7,0,0,1,5.225,4.55l.049.063a19.656,19.656,0,0,1,4.334,12.369Z" transform="translate(-578.577 -2.3)" fill="#fff" /><path d="M600.5,24.617c-1.753,8.181-3.485,16.258-5.315,24.842a19.744,19.744,0,0,1-5.113-4.466,1,1,0,0,1-.125-.174c.57-2.574,1.092-4.918,1.607-7.27s.9-4.724,1.489-7.054c.953-3.868,3.137-5.6,7.465-5.885Z" transform="translate(-580.44 -7.489)" fill="#314159" /><path d="M608.681,24.4h6.191c-1.169,5.44-2.3,10.748-3.457,16.119H605.21c1.176-5.44,2.317-10.748,3.478-16.119Z" transform="translate(-585.084 -7.426)" fill="#314159" /><path d="M619.157,40.5c1.162-5.419,2.261-10.6,3.409-15.966h6.157c-.682,3.277-1.252,6.63-2.087,9.92-.988,4.014-2.887,5.524-7.485,6.045Z" transform="translate(-589.326 -7.465)" fill="#314159" /><path d="M631.7,16.213c-.146.32-.243.55-.341.758H625.2c.39-1.746.758-3.4,1.2-5.391h.028a19.773,19.773,0,0,1,5.225,4.571l.049.063Z" transform="translate(-591.168 -3.524)" fill="#314159" /></g><g transform="translate(143.811 15.096)"><path d="M782,21.71,778.69,41.759H782.7l3.311-20.049Z" transform="translate(-778.69 -21.703)" fill="#314159" /><path d="M810.543,22.294a1.71,1.71,0,0,0-1.336-.584h-6.038a2.262,2.262,0,0,0-1.5.584,2.315,2.315,0,0,0-.793,1.405,1.675,1.675,0,0,0-.376-1.405,1.606,1.606,0,0,0-1.308-.584h-6.018a2.185,2.185,0,0,0-1.5.584,2.291,2.291,0,0,0-.842,1.405l-2.978,18.06h4.007l2.651-16.042h4.028l-2.651,16.042h3.986l2.651-16.042h4.028L803.9,41.759h4.007l2.977-18.06a1.729,1.729,0,0,0-.334-1.405Z" transform="translate(-781.478 -21.703)" fill="#314159" /><path d="M834.755,22.294a1.663,1.663,0,0,0-1.308-.584H823.4l-.661,4.007h8.035l-.668,4.028h-8.035L820.09,41.759H824.1l1.322-8.014h6.038a2.3,2.3,0,0,0,1.5-.584,2.46,2.46,0,0,0,.8-1.426l1.329-8.035A1.729,1.729,0,0,0,834.755,22.294Z" transform="translate(-791.289 -21.703)" fill="#314159" /><path d="M855.385,22.294a1.634,1.634,0,0,0-1.308-.584h-8.035a2.185,2.185,0,0,0-1.5.584A2.291,2.291,0,0,0,843.7,23.7l-2.651,16.042a1.632,1.632,0,0,0,.369,1.426,1.578,1.578,0,0,0,1.308.584h8.035a2.262,2.262,0,0,0,1.5-.584,2.348,2.348,0,0,0,.821-1.426L855.732,23.7a1.665,1.665,0,0,0-.355-1.405Zm-5.976,15.479h-4.028l1.99-12.063H851.4Z" transform="translate(-797.658 -21.703)" fill="#314159" /><path d="M875.737,27.728,876.4,23.7a1.666,1.666,0,0,0-.355-1.405,1.634,1.634,0,0,0-1.308-.584h-8.035a2.223,2.223,0,0,0-1.5.584,2.392,2.392,0,0,0-.842,1.405l-1.329,8.035a1.7,1.7,0,0,0,.369,1.426,1.606,1.606,0,0,0,1.308.584h6.018l-.668,4.028h-4.028l.334-2.01h-4.007l-.661,3.986a1.7,1.7,0,0,0,.369,1.426,1.605,1.605,0,0,0,1.308.584h8.035a2.262,2.262,0,0,0,1.5-.584,2.349,2.349,0,0,0,.821-1.426l1.322-8.014a1.751,1.751,0,0,0-.348-1.426,1.688,1.688,0,0,0-1.315-.563h-6.038l.668-4.028h4.028l-.334,2.01h4.007Z" transform="translate(-803.943 -21.703)" fill="#314159" /><path d="M896.378,27.728l.668-4.028a1.729,1.729,0,0,0-.334-1.405,1.681,1.681,0,0,0-1.336-.584h-8.014a2.274,2.274,0,0,0-1.523.584,2.313,2.313,0,0,0-.814,1.405L883.7,31.735a1.69,1.69,0,0,0,.348,1.426,1.652,1.652,0,0,0,1.336.584h6l-.668,4.028H886.68l.334-2.01h-3.986l-.661,3.986a1.69,1.69,0,0,0,.348,1.426,1.652,1.652,0,0,0,1.336.584h8.014a2.314,2.314,0,0,0,1.524-.584,2.46,2.46,0,0,0,.8-1.426l1.322-8.014a1.82,1.82,0,0,0-.327-1.426,1.732,1.732,0,0,0-1.336-.563h-6.038l.668-4.028H892.7l-.334,2.01h4.007Z" transform="translate(-810.232 -21.703)" fill="#314159" /><path d="M905.891,21.71,902.58,41.759h4.007L909.9,21.71Z" transform="translate(-816.393 -21.703)" fill="#314159" /><path d="M925.761,29.738l.995-6.038a1.729,1.729,0,0,0-.334-1.405,1.71,1.71,0,0,0-1.336-.584H915.061l-.661,4.007h8.014l-.668,4.028h-8.014L911.75,41.759h10.025a2.354,2.354,0,0,0,1.524-.584,2.46,2.46,0,0,0,.8-1.426l.988-6a1.755,1.755,0,0,0-.327-1.426,1.71,1.71,0,0,0-1.336-.584,2.354,2.354,0,0,0,1.524-.584,2.422,2.422,0,0,0,.793-1.405Zm-5.329,8.035H916.4l.668-4.028H921.1Z" transform="translate(-819.184 -21.703)" fill="#314159" /><path d="M937.088,37.77l2.651-16.07h-4.007L932.42,41.749h12.014l.661-3.986h-8.014Z" transform="translate(-825.474 -21.7)" fill="#314159" /><path d="M957.791,37.77l.668-4.028H964.5l.661-4.007H955.113L953.13,41.749h12.042l.661-3.986H957.8ZM956.434,21.7l-.661,4.007h12.042l.661-4.007Z" transform="translate(-831.777 -21.7)" fill="#314159" /></g><g transform="translate(53.831 14.88)"><path d="M668.756,21.96a1.663,1.663,0,0,0-1.322-.57H657.243l-.717,4.056h8.146l-.717,4.07H655.81l-2.15,12.2h4.056l1.433-8.146h6.143a2.306,2.306,0,0,0,1.517-.57,2.462,2.462,0,0,0,.842-1.461l1.433-8.146a1.763,1.763,0,0,0-.334-1.44Z" transform="translate(-653.66 -21.39)" fill="#314159" /><path d="M679.192,37.672,682.058,21.4H678L674.42,41.721h12.2l.717-4.056h-8.146Z" transform="translate(-659.978 -21.393)" fill="#314159" /><path d="M710.289,21.96a1.7,1.7,0,0,0-1.336-.57h-8.146a2.23,2.23,0,0,0-1.517.57,2.4,2.4,0,0,0-.863,1.44L695.2,41.718h4.056l1.433-8.146h4.07l-1.433,8.146h4.056L710.609,23.4a1.755,1.755,0,0,0-.313-1.44Zm-4.821,7.555H701.4l.717-4.07h4.07Z" transform="translate(-666.302 -21.39)" fill="#314159" /><path d="M718.08,29.525l-2.15,12.2h4.056l2.15-12.2Zm12.94-7.555a1.658,1.658,0,0,0-1.315-.57H719.513l-.717,4.056h8.146l-2.866,16.272h4.056L731.36,23.41a1.763,1.763,0,0,0-.334-1.44Z" transform="translate(-672.61 -21.393)" fill="#314159" /><path d="M740.286,21.4l-.717,4.056h12.2l.717-4.056Zm1.183,16.272.723-4.091h6.122l.717-4.056H738.86l-2.15,12.2h12.2l.717-4.056h-8.146Z" transform="translate(-678.934 -21.393)" fill="#314159" /><path d="M762.3,21.4l-.717,4.056h4.056L762.77,41.728h4.07l2.866-16.272h4.056l.717-4.056H762.3Z" transform="translate(-686.503 -21.393)" fill="#314159" /></g></g></svg>
        )
    }
}

export default function PrimarySearchAppBar() {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const token = AgentJwtService.getDecodedAccessToken();

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>My account</MenuItem>
            <MenuItem onClick={() => {
                dispatch(logoutUser());
            }}>
                Logout
            </MenuItem>
        </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem>
                <IconButton size="large" aria-label="show 4 new mails" color="inherit" edge={false}>
                    <Badge badgeContent={4} color="error">
                        <MailIcon />
                    </Badge>
                </IconButton>
                <p>Messages</p>
            </MenuItem>

            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    edge={false}
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                ></IconButton>

                <p>Profile</p>
            </MenuItem>
        </Menu>
    );
    const [state, setState] = React.useState({
        left: false,
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };
    const sideBarList = (anchor) => (
        <Box
            sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 300 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <PublicSidebarLeft />
        </Box>
    );
    const notificationList = (anchor) => (
        <Box
            sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 300 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            notificationList
        </Box>
    );

    class ReactComments extends React.Component {
        render() {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.13em" viewBox="0 0 41.934 33.859">
                    <g id="Icon_awesome-comments" data-name="Icon awesome-comments" transform="translate(2.8 0.55)" fill="none">
                        <path d="M26.241,12.343c0-5.576-5.873-10.093-13.121-10.093S0,6.766,0,12.343a8.558,8.558,0,0,0,2.4,5.8A14.2,14.2,0,0,1,.139,21.584a.5.5,0,0,0-.095.549.494.494,0,0,0,.46.3,11.107,11.107,0,0,0,5.6-1.577,16.051,16.051,0,0,0,7.021,1.577C20.368,22.435,26.241,17.919,26.241,12.343Zm7.7,13.878a8.546,8.546,0,0,0,2.4-5.8c0-4.22-3.375-7.834-8.156-9.342a9.374,9.374,0,0,1,.082,1.268c0,6.68-6.794,12.111-15.139,12.111a18.912,18.912,0,0,1-2-.12c1.987,3.627,6.655,6.175,12.092,6.175a15.963,15.963,0,0,0,7.021-1.577,11.107,11.107,0,0,0,5.6,1.577.5.5,0,0,0,.46-.3.505.505,0,0,0-.095-.549A14.047,14.047,0,0,1,33.937,26.22Z" stroke="none" />
                        <path d="M 13.12055206298828 2.25 C 5.872711181640625 2.25 0 6.766498565673828 0 12.34273910522461 C 0 14.50636863708496 0.8894233703613281 16.49967956542969 2.397022247314453 18.14605903625488 C 1.551761627197266 20.05105972290039 0.1577033996582031 21.56496810913086 0.1387710571289062 21.58390045166016 C 0 21.72897911071777 -0.03784942626953125 21.94344902038574 0.04415130615234375 22.1326904296875 C 0.1261634826660156 22.32192993164062 0.3027801513671875 22.43547058105469 0.5046310424804688 22.43547058105469 C 2.813350677490234 22.43547058105469 4.724660873413086 21.65958976745605 6.09979248046875 20.85847854614258 C 8.130962371826172 21.84882926940918 10.53429222106934 22.43547058105469 13.12055206298828 22.43547058105469 C 20.36840057373047 22.43547058105469 26.24111175537109 17.91896820068359 26.24111175537109 12.34273910522461 C 26.24111175537109 6.766498565673828 20.36840057373047 2.25 13.12055206298828 2.25 M 28.17765045166016 11.07483863830566 C 28.23442077636719 11.49115943908691 28.25965118408203 11.91378974914551 28.25965118408203 12.34273910522461 C 28.25965118408203 19.02285957336426 21.46598052978516 24.45401954650879 13.12055206298828 24.45401954650879 C 12.43929100036621 24.45401954650879 11.77696228027344 24.40354919433594 11.12093162536621 24.33415985107422 C 13.10794067382812 27.96123886108398 17.77583122253418 30.50965881347656 23.21329116821289 30.50965881347656 C 25.79955291748047 30.50965881347656 28.202880859375 29.92932891845703 30.23405075073242 28.93266868591309 C 31.60918045043945 29.73377990722656 33.52049255371094 30.50965881347656 35.8292121887207 30.50965881347656 C 36.03106307983398 30.50965881347656 36.21399307250977 30.38979911804199 36.28969192504883 30.20686912536621 C 36.3716926574707 30.02393913269043 36.33384323120117 29.80946922302246 36.19507217407227 29.65807914733887 C 36.17613983154297 29.63916015625 34.78208160400391 28.13154983520508 33.93682098388672 26.22024917602539 C 35.44441986083984 24.58016967773438 36.33384323120117 22.5805492401123 36.33384323120117 20.41691970825195 C 36.33384323120117 16.1968994140625 32.95909118652344 12.58243942260742 28.17765045166016 11.07483863830566 M 13.12055206298828 -0.5499992370605469 C 17.24017143249512 -0.5499992370605469 21.14151191711426 0.7057304382324219 24.10589218139648 2.985879898071289 C 25.61889266967773 4.149639129638672 26.81600189208984 5.521879196166992 27.66396141052246 7.064449310302734 C 27.85861587524414 7.418556213378906 28.03282737731934 7.777811050415039 28.18647766113281 8.141740798950195 L 29.0196418762207 8.404439926147461 C 31.8833122253418 9.30735969543457 34.34563064575195 10.8505687713623 36.14041137695312 12.86723899841309 C 38.09873199462891 15.06766891479492 39.13384246826172 17.67831039428711 39.13384246826172 20.41691970825195 C 39.13384246826172 22.56643295288086 38.49696731567383 24.63212585449219 37.27593231201172 26.48453330993652 C 37.72997665405273 27.16740036010742 38.15375518798828 27.64914512634277 38.23162841796875 27.7360782623291 L 38.25913238525391 27.76607894897461 C 39.14462280273438 28.73210144042969 39.37891387939453 30.12077331542969 38.86117935180664 31.31488418579102 C 38.34181213378906 32.52805709838867 37.15618896484375 33.30965805053711 35.8292121887207 33.30965805053711 C 33.87829971313477 33.30965805053711 31.96732330322266 32.88093948364258 30.13084983825684 32.03317642211914 C 27.98227691650391 32.87116622924805 25.61877059936523 33.30965805053711 23.21329116821289 33.30965805053711 C 20.13449096679688 33.30965805053711 17.1492919921875 32.60289001464844 14.58040237426758 31.26574897766113 C 11.96779251098633 29.90584945678711 9.922370910644531 27.97414016723633 8.665271759033203 25.67943000793457 L 8.055091857910156 24.56560707092285 C 7.424924850463867 24.39465713500977 6.807401657104492 24.19184303283691 6.205610275268555 23.95777893066406 C 4.368370056152344 24.80630493164062 2.456432342529297 25.23546981811523 0.5046310424804688 25.23546981811523 C -0.8120498657226562 25.23546981811523 -2.001247406005859 24.4545783996582 -2.524978637695312 23.24605941772461 C -3.050785064697266 22.03258895874023 -2.808444976806641 20.63454627990723 -1.908725738525391 19.6739387512207 C -1.856544494628906 19.61594581604004 -1.415420532226562 19.11972427368164 -0.9417610168457031 18.40716171264648 C -2.162906646728516 16.55187797546387 -2.799999237060547 14.4870491027832 -2.799999237060547 12.34273910522461 C -2.799999237060547 10.50268936157227 -2.336658477783203 8.72681999206543 -1.422847747802734 7.064449310302734 C -0.57489013671875 5.521879196166992 0.622222900390625 4.149639129638672 2.135223388671875 2.985879898071289 C 5.099601745605469 0.7057304382324219 9.000930786132812 -0.5499992370605469 13.12055206298828 -0.5499992370605469 Z" stroke="none" fill="#48525c" />
                    </g>
                </svg>
            )
        }
    }

    const isMobileSize = useMediaQuery("(max-width:420px)");
    return (
        <>
            <AppBar position="sticky" elevation={2} className=" h-76 bg-white shadow z-10">
                <Toolbar className=" m-auto w-full"
                    sx={(theme) => ({
                        '& .MuiFormControl-root.MuiTextField-root.mb-24': {
                            marginBottom: "unset",
                            flexGrow: .5,
                        },
                        '&.MuiToolbar-root': {
                            gap: "1.5rem",
                            '& .flex': {
                                gap: "1.5rem",
                            },
                            [theme.breakpoints.down("sm")]: {
                                gap: ".8rem",
                                '& .flex': {
                                    gap: isMobileSize ? ".4rem" : ".8rem",
                                },
                            },
                        }
                    })}>
                    {["left"].map((anchor) => (
                        <React.Fragment key={anchor}>
                            <IconButton
                                className="block max1200px:hidden -mr-16"
                                onClick={toggleDrawer(anchor, true)}
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ display: "flex", }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                            >
                                {sideBarList(anchor)}
                            </Drawer>
                        </React.Fragment>
                    ))}
                    <Box className=" xsm:w-full w-1/2 block max1200px:hidden">
                        <PiLogo />
                    </Box>

                    <div className=" flex items-center max-900px:w-unset w-full">

                        <SearchBar id={token.id} />

                        <Hidden mdDown>
                            <Button
                                component={Link}
                                to="/public/create-mission"
                                className="bg-pi-yellow-green rounded-full text-16 font-bold hover:bg-pi-hover-yellow text-pi-dark-blue-text min-w-fit truncate pr-16"
                            >
                                {" "}
                                <Icon className="mr-5">add</Icon> Create A Mission
                            </Button>
                        </Hidden>
                        <Hidden mdUp>
                            <IconButton
                                edge={false}
                                component={Link}
                                to="/public/create-mission"
                                className=" bg-pi-yellow-green text-pi-black hover:bg-pi-yellow-green"
                                sx={{ padding: isMobileSize ? '5px' : "10px" }}
                            >
                                <Add />
                            </IconButton>
                        </Hidden>
                        <Hidden mdDown>
                            <Box sx={{ flexGrow: 3 }} />
                        </Hidden>
                        {Object.keys(token).length > 0 ?
                            <>
                                <IconButton
                                    sx={{ display: "flex", padding: isMobileSize ? '5px' : "10px" }}
                                    aria-label="Search"
                                    color="inherit"
                                    className="xsm:block hidden"
                                >
                                    <FiSearch size={isMobileSize ? '30px' : "40px"} className=" text-pi-dark-blue" />
                                </IconButton>
                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                    {(popupState) => (
                                        <div className="max-900px:block hidden">
                                            <IconButton sx={{ padding: 0 }} size="large" {...bindTrigger(popupState)} edge={false}>
                                                <StyledBadge
                                                    overlap="circular"
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                    variant="dot"

                                                >
                                                    <Avatar sx={{ width: isMobileSize ? '30px' : "40px", height: isMobileSize ? '30px' : "40px" }} alt="Remy Sharp" src="/material-ui-static/images/avatar/1.jpg" />
                                                </StyledBadge>
                                            </IconButton>
                                            <Popover
                                                {...bindPopover(popupState)}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'center',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'center',
                                                }}
                                            >
                                                <nav aria-label="Menu" className=" w-192">
                                                    <List>
                                                        <ListItem disablePadding>
                                                            {["right"].map((anchor) => (
                                                                <React.Fragment key={anchor}>
                                                                    <ListItemButton onClick={toggleDrawer(anchor, true)}>
                                                                        <ListItemText primary={<Typography className=" text-16">Notifications</Typography>} />
                                                                        <Badge badgeContent={100} color="error" sx={{ '& .MuiBadge-anchorOriginTopRightRectangular': { position: 'unset', transform: 'unset', } }}>
                                                                        </Badge>
                                                                    </ListItemButton>

                                                                    <Drawer
                                                                        anchor={anchor}
                                                                        open={state[anchor]}
                                                                        onClose={toggleDrawer(anchor, false)}
                                                                    >
                                                                        {notificationList(anchor)}
                                                                    </Drawer>
                                                                </React.Fragment>
                                                            ))}
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton component={Link}
                                                                to="/public/friend-activity">
                                                                <ListItemText primary={<Typography className=" text-16">Friends Activity</Typography>} />
                                                                <Badge badgeContent={100} color="error" sx={{ '& .MuiBadge-anchorOriginTopRightRectangular': { position: 'unset', transform: 'unset', } }}>
                                                                </Badge>
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton component="b" onClick={() => dispatch(logoutUser())} >
                                                                <ListItemText primary={<Typography className=" text-16">Logout</Typography>} />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </nav>
                                            </Popover>
                                        </div>
                                    )}
                                </PopupState>
                            </>
                            :
                            ""
                        }
                    </div>
                    {Object.keys(token).length > 0 ?
                        <div className="max-900px:hidden flex">
                            {["right"].map((anchor) => (
                                <React.Fragment key={anchor}>
                                    <IconButton
                                        size="large"
                                        onClick={toggleDrawer(anchor, true)}
                                        sx={{ display: "flex", fontSize: '3.5rem' }}
                                        aria-label="General Notifications"
                                        color="inherit"
                                    >
                                        <BadgeStyled variant="dot" color="error" invisible={false}>
                                            <FiBell className=" text-pi-dark-blue" />
                                        </BadgeStyled>
                                    </IconButton>
                                    <Drawer
                                        anchor={anchor}
                                        open={state[anchor]}
                                        onClose={toggleDrawer(anchor, false)}
                                    >
                                        {notificationList(anchor)}
                                    </Drawer>
                                </React.Fragment>
                            ))}
                            <IconButton
                                size="large"
                                sx={{ display: "flex", fontSize: '3.5rem', padding: '10px' }}
                                aria-label="Friends Notifications"
                                color="inherit"
                            >
                                <BadgeStyled variant="dot" color="error" invisible={true}>
                                    <ReactComments />
                                </BadgeStyled>
                            </IconButton>
                            <IconButton
                                size="large"
                                sx={{ display: "flex", fontSize: '3.8rem' }}
                                aria-label="Logout"
                                color="inherit"
                                onClick={() => dispatch(logoutUser())}
                            >
                                <BadgeStyled variant="dot" color="error" invisible={true}>
                                    <MdPowerSettingsNew className=" text-pi-dark-blue" />
                                </BadgeStyled>
                            </IconButton>
                        </div>
                        :
                        <Button component={Link} to="/agentlogin" variant="outlined" color="secondary" className=" self-center py-4 px-24 text-pi-blue-1 border-pi-text-grey hover:border-pi-text-grey text-18 rounded-full font-bold ml-14"> <Icon className="mr-6 text-pi-blue-1 fill-pi-blue-1">account_circle</Icon> Login</Button>
                    }
                </Toolbar>
            </AppBar >
            {renderMobileMenu}
            {renderMenu}
        </>
    );
}
